<template>
  <div>
    Test
  </div>
</template>

<script>
export default {
  routerOption: {
    as_default: true,
  },
};
</script>

<style lang="scss" scoped>

</style>
